__turbopack_context__.v({
  "description": "_0DNkBG_description",
  "emphasis": "_0DNkBG_emphasis",
  "exposureTypeList": "_0DNkBG_exposureTypeList",
  "grayBg": "_0DNkBG_grayBg",
  "heresHowWeHelpCta": "_0DNkBG_heresHowWeHelpCta",
  "heresHowWeHelpWrapper": "_0DNkBG_heresHowWeHelpWrapper",
  "hero": "_0DNkBG_hero",
  "heroContent": "_0DNkBG_heroContent",
  "heroImage": "_0DNkBG_heroImage",
  "heroImageBadge": "_0DNkBG_heroImageBadge",
  "illustration": "_0DNkBG_illustration",
  "item": "_0DNkBG_item",
  "label": "_0DNkBG_label",
  "lead": "_0DNkBG_lead",
  "navbar": "_0DNkBG_navbar",
  "nr": "_0DNkBG_nr",
  "planName": "_0DNkBG_planName",
  "plans": "_0DNkBG_plans",
  "pressLogos": "_0DNkBG_pressLogos",
  "quote": "_0DNkBG_quote",
  "quoteWrapper": "_0DNkBG_quoteWrapper",
  "reverseRow": "_0DNkBG_reverseRow",
  "signUpEncouragementWrapper": "_0DNkBG_signUpEncouragementWrapper",
  "socialProofWrapper": "_0DNkBG_socialProofWrapper",
  "title": "_0DNkBG_title",
  "valuePropositionWrapper": "_0DNkBG_valuePropositionWrapper",
  "waitlistCta": "_0DNkBG_waitlistCta",
  "waitlistSection": "_0DNkBG_waitlistSection",
  "waitlistTitle": "_0DNkBG_waitlistTitle",
  "wrapper": "_0DNkBG_wrapper",
});
